import { Component, h, Prop, Host } from '@stencil/core';
import { isPercent } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-skeleton',
  styleUrl: 'ugc-skeleton.scss',
  shadow: false,
})
export class UgcSkeleton {
  @Prop() width?: string | number = '';
  @Prop() height?: string | number = '';
  @Prop() isCircle?: boolean;
  @Prop() duration?: number;
  @Prop() customStyle?: any;

  getStyle = () => {
    let style: any = {};

    if (!!this.width) {
      style.width = isPercent(`${this.width}`) ? this.width : `${this.width}px`;
    }

    if (!!this.height) {
      style.height = isPercent(`${this.height}`) ? this.height : `${this.height}px`;
    }

    if (!!this.width && !!this.height && this.isCircle) {
      style.borderRadius = '50%';
    }
    return style;
  };

  render() {
    return (
      <Host class="ugc-skeleton-item" style={{ ...this.getStyle(), ...this.customStyle }}>
        &zwnj;
      </Host>
    );
  }
}
